import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'
import { SuccessDialog } from '../confirmation/SuccessDialog'

export const AccessFileErrorDialog: FunctionComponent<React.PropsWithChildren<{
  title: string
  text: string
  ctaLabel: string
}>> = ({ title, text, ctaLabel }) => {
  const router = useRouter()

  const { error } = router.query
  const isOpen = !!error

  const onClose = () => {
    // Remove query param "error"
    router.push({ query: { slug: router.query.slug } }, {}, { shallow: true })
  }

  return (
    <SuccessDialog
      text={text}
      title={title}
      ctaLabel={ctaLabel}
      open={isOpen}
      onHandleClose={onClose}
    />
  )
}
